import NaptimeResource from './NaptimeResource';

export default class GuidedCourseSessionProgresses extends NaptimeResource {
  static RESOURCE_NAME = 'guidedCourseSessionProgresses.v1';
}
